import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

export default function RecuperarSenha() {
  const [email, setEmail]   = useState('');
  const [msg, setMsg]       = useState('');
  const [loading, setLoading] = useState(false);

  const enviar = async e => {
    e.preventDefault(); setLoading(true);
    try { await api.post('/auth/recuperar-senha', { email }); setMsg('ok'); }
    catch { setMsg('erro'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', background:'var(--ink)', display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
      <div style={{ width:'100%', maxWidth:420 }}>
        <Link to="/" style={{ display:'flex', alignItems:'center', gap:12, marginBottom:36, justifyContent:'center' }}>
          <img src="/assets/heritage-logo-transparent.png" alt="Heritage" style={{ width:48, height:48, objectFit:'contain' }} />
          <span style={{ fontFamily:"'Playfair Display',serif", fontSize:22, color:'#fff', fontWeight:700 }}>Heritage BH</span>
        </Link>

        <div style={{ background:'#fff', borderRadius:'var(--r-md)', padding:'36px 40px', boxShadow:'var(--shadow-lg)' }}>
          <div className="eyebrow">Acesso</div>
          <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:24, fontWeight:600, marginBottom:8 }}>Recuperar senha</h1>
          <p style={{ fontSize:13, color:'var(--ink-muted)', marginBottom:26 }}>Informe seu e-mail e enviaremos as instruções.</p>

          {msg === 'ok' ? (
            <div className="alert alert-success">Instruções enviadas! Verifique sua caixa de entrada.</div>
          ) : (
            <form onSubmit={enviar}>
              {msg === 'erro' && <div className="alert alert-danger">Erro ao processar. Tente novamente.</div>}
              <div className="form-group"><label>E-mail</label><input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus /></div>
              <button type="submit" className="btn btn-primary" style={{ width:'100%', minHeight:50 }} disabled={loading}>
                {loading ? 'Enviando…' : 'Enviar instruções'}
              </button>
            </form>
          )}
          <p style={{ textAlign:'center', fontSize:13, color:'var(--ink-muted)', marginTop:22 }}>
            <Link to="/login" style={{ color:'var(--rust)', fontWeight:900 }}>← Voltar ao login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
